import { FC, useEffect } from 'react';
import { Fade, Paper, Box, Typography, Button } from '@mui/material';
import FlagLanderBanner from '@acorn-portal/shared/src/components/banner/FlagLanderBanner';
import { useNavigate } from 'react-router';
import Home from '@mui/icons-material/Home';
import { useAppDispatch } from '@acorn-portal/shared/src/hooks/reduxHook';
import { clearMidTermAdjustmentDetails } from '@acorn-portal/shared/src/store/midTermAdjustment.slice';
import { resetApiMTA } from '@acorn-portal/shared/src/store/midTermAdjustmentAPI.sclice';

const MtaReferralPage: FC = () => {
	const navigate = useNavigate();
	const dispatch = useAppDispatch();

	useEffect(() => {
		dispatch(clearMidTermAdjustmentDetails());
		dispatch(resetApiMTA());
	}, [dispatch]);

	return (
		<Paper
			elevation={1}
			sx={{
				borderRadius: '8px',
			}}
		>
			<Fade in>
				<Box>
					<FlagLanderBanner
						text={
							<Box
								sx={(theme) => ({
									[theme.breakpoints.down('md')]: { fontSize: '1.4rem' },
									[theme.breakpoints.down('sm')]: {
										fontSize: '1.1rem',
									},
									width: '80%',
								})}
							>
								We&apos;re reviewing your Quote.
							</Box>
						}
					/>
					<Box
						sx={{
							display: 'flex',
							justifyContent: 'center',
							flexDirection: 'column',
							alignItems: 'center',
							textAlign: 'center',
							px: 2,
							'& > *': { mb: 3 },
						}}
					>
						<Box
							sx={(theme) => ({
								mt: 4,
								mx: '10%',
								'& > *': { mb: 3 },
								[theme.breakpoints.down('md')]: {
									mx: 'unset',
								},
							})}
						>
							<Box>
								<Typography variant='h6' fontWeight='lighter'>
									Thank you for requesting a quote with Flag today for a change on your policy. Unfortunately, we are
									unable to progress with the proposed change at this time.
								</Typography>
							</Box>
							<Typography>
								Please visit the{' '}
								<a href='https://www.flaginsurance.co.uk/get-in-touch/' target='_blank' rel='noreferrer'>
									Contact Us
								</a>{' '}
								page on our website if you wish to discuss your change
							</Typography>
							<Typography>
								Thank you for your interest in Flag insurance - we look forward to speaking to you soon.
							</Typography>
						</Box>
						<Button
							startIcon={<Home />}
							size='large'
							variant='contained'
							onClick={() => {
								navigate('/portal/home');
								return null;
							}}
						>
							Return to homepage
						</Button>
						<Box sx={{ margin: 2 }} />
					</Box>
				</Box>
			</Fade>
		</Paper>
	);
};

export default MtaReferralPage;
